module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('form', {
    ref: "form",
    staticClass: "rf-form",
    class: {
      'rf-form-busy': _vm.state.busy
    },
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm._onEnterKey(null, $event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm._onEnterKey(null, $event)
      }
    }
  }, [_c('div', {
    staticClass: "rf-form-busy-mask"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rf-form-body"
  }, [_vm._t("default", null, {
    form: this
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4296f51f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/RfForm.vue
// module id = 257
// module chunks = 0